module.exports = __webpack_public_path__ + "static/media/checked_checkbox.91240157.svg";